import { Button, Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useStyles } from './myAddress.style'
import DialogAlert from '../../../../components/common/DialogAlert'
import { ClipLoader } from 'react-spinners'
import { t } from 'i18next'
import i18n from '../../../language/localization'
import {
  getDetail as getAddressDetail,
  setDefault as setDefaultAddress
} from '../../../../api/address'

const MyAddress = props => {
  const { webThemeColor } = props
  const classes = useStyles(props)
  const [SetDefaultOpen, setSetDefaultOpen] = React.useState(false)
  const [isLoading, setLoading] = React.useState(false)
  const [myIndex, setIndex] = React.useState()
  const [defaultId, setDefaultId] = React.useState('')
  const [selectedId, setSelectedId] = React.useState('')
  const [addressDatas, setAddressDatas] = useState([])

  useEffect(() => {
    i18n.changeLanguage(JSON.parse(localStorage.getItem('Language')))
  }, [])

  const handleSetDefaultAddress = async () => {
    try {
      const mutations = []

      addressDatas.forEach(curr => {
        const customer_address_mapping_id =
          curr.customer_address_mappings?.[0]?.customer_address_mapping?.id ?? ''

        if (customer_address_mapping_id) {
          if (curr.customer_address.id === selectedId) {
            mutations.push(setDefaultAddress({ customer_address_mapping_id, is_primary: true }))
          }

          if (curr.customer_address.id === defaultId) {
            mutations.push(setDefaultAddress({ customer_address_mapping_id, is_primary: false }))
          }
        }
      })

      await Promise.all(mutations)

      await getAddressData()
    } catch (error) {
      console.log('Error fetching getAddress:', error)
    }

    handleSetDefaultClose()
  }

  const getAddressData = async () => {
    const userID = JSON.parse(localStorage.getItem('userid'))
    try {
      const response = await getAddressDetail(`{"customer_id":${userID}}`)
      const primaryAddress = response.find(
        r => r.customer_address_mappings?.[0]?.customer_address_mapping?.is_primary
      )

      if (!primaryAddress && response.length === 1) {
        setSelectedId(response[0].customer_address.id)
        setTimeout(handleSetDefaultAddress, 300)
      }

      setDefaultId(primaryAddress?.customer_address?.id)
      setAddressDatas(response)
    } catch (error) {
      console.log('Error fetching getAddress:', error)
    }
  }

  useEffect(() => {
    getAddressData()
  }, [])

  const handleSetDefaultClose = () => {
    setSetDefaultOpen(false)
  }
  const DefaultAddress = (id, index) => {
    setIndex(index)
    setLoading(true)
    setLoading(false)
    setSetDefaultOpen(true)
    setSelectedId(id)
  }

  return (
    <div className={classes.body}>
      <header>
        <Grid container spacing={2} className={''}>
          <Grid item md={3}>
            <h3 className={classes.title}>{t('my_address')}</h3>
          </Grid>
        </Grid>
        <hr />
      </header>

      {addressDatas && addressDatas.length > 0
        ? addressDatas.map((item, index) => {
            const isPrimary =
              item.customer_address_mappings?.[0]?.customer_address_mapping?.is_primary

            return (
              <div
                key={index}
                style={{
                  borderBottom: '1px solid #EBEBEB',
                  paddingTop: '20px',
                  paddingBottom: '20px'
                }}
              >
                <Grid container spacing={4}>
                  <Grid item md={9}>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                      <span>{item.customer_address.name}</span>
                      <span>{item.customer_address.phone}</span>
                    </div>
                  </Grid>
                  <Grid item md={3} style={{ textAlign: 'right' }}>
                    {isPrimary ? (
                      <Button
                        variant='outlined'
                        color='secondary'
                        size='small'
                        style={{
                          color: '#DC6803',
                          border: '1px #DC6803 solid',
                          textTransform: 'capitalize'
                        }}
                      >
                        {t('default_unbold')}
                      </Button>
                    ) : (
                      <Button
                        style={{
                          color: webThemeColor,
                          background: 'transparent',
                          border: '1px ' + webThemeColor + ' solid',
                          height: '25px',
                          textTransform: 'capitalize',
                          whiteSpace: 'nowrap'
                        }}
                        onClick={() => DefaultAddress(item.customer_address.id, index)}
                        size='small'
                      >
                        {index == myIndex && isLoading ? (
                          <ClipLoader size={27} color={webThemeColor} />
                        ) : (
                          t('set_as_default_address')
                        )}
                      </Button>
                    )}
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid item md={9}>
                    {item.customer_address.address}
                  </Grid>
                  <Grid item md={9}>
                    {item.sub_district.name}, {item.district.name}, {item.province.name}
                    {item.sub_district.postal_code ? `- ${item.sub_district.postal_code}` : ''}
                  </Grid>
                </Grid>
              </div>
            )
          })
        : null}

      <DialogAlert
        yesno='true'
        open={SetDefaultOpen}
        close={handleSetDefaultClose}
        no={handleSetDefaultClose}
        ok={handleSetDefaultAddress}
      >
        {t('address_set_as_default_confirmation')}
      </DialogAlert>
    </div>
  )
}

export default MyAddress
